import jsPDF from 'jspdf'
import 'jspdf-autotable'

export const depTable = (deps, livs) => {
    const doc = new jsPDF('p', 'mm')
    let nbPage = 1
    let head = ['#', 'Date', 'Heure', 'Employé', 'Nom', 'Appel', 'Lieu', 'Marque', 'Plaques', 'Total']
    let head2 = ['#', 'Date', 'Heure', 'Livré par', 'Nom', 'Appel', 'Lieu', 'Marque', 'Plaques', 'Total']
    let options = {
        // theme: 'grid',
        styles: {
            font: 'times'
        },
        headStyles: {
            valign: 'middle',
            halign: 'center'
        },
        bodyStyles: {
            valign: 'middle',
            halign: 'center'
        },
        didDrawPage: () => {
            doc.setFontSize(8)
            doc.setFont(undefined, 'normal')
            doc.setFont('times')
            doc.text(nbPage.toString(), 105, 290, 'center')
            nbPage++
        }
    }
    let body = []
    let index = 1
    for (let dep of deps) {
        let temp = []
        temp.push(index)
        temp.push(dep.date)
        temp.push(dep.heure)
        temp.push(dep.employe)
        temp.push(dep.nom)
        temp.push(dep.appel)
        temp.push(dep.lieu)
        temp.push(dep.marque)
        temp.push(dep.plaques)
        temp.push(dep.totalFinal)
        body.push(temp)
        index++
    }
    doc.autoTable(
        head,
        body,
        options
    )
    if (livs.length > 0) {
        body = []
        index = 1
        for (let dep of livs) {
            let temp = []
            temp.push(index)
            temp.push(dep.livDate)
            temp.push(dep.livHeure)
            temp.push(dep.livEmp)
            temp.push(dep.nom)
            temp.push(dep.appel)
            temp.push(dep.lieu)
            temp.push(dep.marque)
            temp.push(dep.plaques)
            temp.push(dep.livTot)
            body.push(temp)
            index++
        }
        doc.autoTable(
            head2,
            body,
            options
        )
    }
    doc.save()
}